import { RefObject, useEffect, useState } from 'react';

/**
 * This hook returns the bounding rect values of the element passed by reference.
 * These values will update on page resize.
 *
 * @param ref The reference to DOM node
 */
const useClientRect = (ref: RefObject<HTMLElement>) => {
  const [clientRectState, setClientRectState] = useState({
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
  });

  useEffect(() => {
    const elem = ref.current;

    if (!elem) {
      return;
    }

    const handleClientRectState = () => {
      if (elem) {
        setClientRectState(elem.getBoundingClientRect());
      }
    };

    handleClientRectState();

    window.addEventListener('resize', handleClientRectState);

    return () => {
      window.removeEventListener('resize', handleClientRectState);
    };
  }, [ref]);

  return clientRectState;
};

export default useClientRect;
